@import "../global.css";
@import "../shared.css";
@import "@videojs/skins/minimal/css/video.css";
